// Every provider sends users back to one registered redirect URI (https://waterspeedapp.web.app), but
// the app also runs on go.waterspeedapp.com. Firebase Auth is per origin, so a connection started on
// go. lands here signed out. Such a callback is sent on to the app's own origin, where the user is
// signed in and the regular handlers finish the connection.

const OAUTH_CALLBACK_PARAMS = ["code", "error", "oauth_token", "oauth_verifier"];

export const isOAuthCallbackQuery = (search: string): boolean => {
  const params = new URLSearchParams(search);
  return OAUTH_CALLBACK_PARAMS.some((name) => params.has(name));
};

interface ForwardInput {
  currentUrl: string;
  appUrl: string | undefined;
  redirectUri: string | undefined;
  isSignedIn: boolean;
}

/** The URL to forward a signed-out OAuth callback to, or null to handle it here. */
export const oauthCallbackForwardUrl = ({currentUrl, appUrl, redirectUri, isSignedIn}: ForwardInput): string | null => {
  if (isSignedIn || !appUrl || !redirectUri) return null;

  let current: URL;
  let app: URL;
  let redirect: URL;
  try {
    current = new URL(currentUrl);
    app = new URL(appUrl);
    redirect = new URL(redirectUri);
  } catch {
    return null;
  }

  if (current.origin !== redirect.origin || current.origin === app.origin) return null;
  if (!isOAuthCallbackQuery(current.search)) return null;

  return `${app.origin}${current.pathname}${current.search}${current.hash}`;
};
